import SmallCard from '@/components/Cards/SmallCard';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import BookDemoForm from '@/components/BookDemoForm';

const services = [
  {
    title: 'Nyproduktion',
    description:
      'Utforska nyproduktionsmarknadsläget – från att ett projekt är planerat tills det säljs som succession. Data kommer från över 9000 bostadsprojekt och 300 bostadsutvecklare.',
  },
  {
    title: 'Succession',
    description:
      'Få tillgång till veckofärsk data om flödet och temperaturen på bostadsmarknaden. Över 30 serier om utbud, snart till salu, budgivningar, försäljningstakt med mera.',
  },
  {
    title: 'BRF-tjänst',
    description:
      'Brf-tjänsten är ett samarbete mellan Booli och SBAB. Följ viktiga nyckeltal från Årsredovisningar från 20 000 + bostadsrättsföreningar, t ex belåning, årsavgiftsnivå och försäljningar i brf:en.',
  },
  {
    title: 'Mäklardata',
    description:
      'I Booli Pro hittar du information om alla registrerade fastighetsmäklare och mäklarbyråer i Sverige. Se hur enskilda mäklare presterar och jämför marknadsandelar.',
  },
  {
    title: 'Dataköp',
    description:
      'Booli Pro är en abonnemangstjänst som tecknas årsvis. Om du är intresserad av specialanpassad data, mejla oss på pro@booli.se.',
  },
  {
    title: 'Boka demo',
    description: 'Klicka här för att boka en demo där du får lära dig mer om vårt analysverktyg.',
    component: <BookDemoForm />,
  },
];

const ProServices = () => {
  return (
    <div className='flex flex-col'>
      <h2 className='mobile:text-lg text-xl'>Tjänster</h2>
      <p className='tablet:text-3xl mobile:text-2xl mt-1 max-w-xl text-4xl font-semibold'>
        Underlätta för rätt beslut på bostadsmarknaden
      </p>
      <div className='relative'>
        <div
          className='tablet:scrollbar laptop:grid-cols-2 tablet:flex tablet:gap-0 tablet:space-x-4
            tablet:overflow-x-auto mt-8 grid max-w-full grid-cols-3 gap-6 pb-6'
        >
          {services.map((service) => {
            return (
              <SmallCard
                key={service.title}
                title={service.title}
                description={service.description}
                component={service?.component}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProServices;
